var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTalkingInformational(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85087 9.49934C8.85223 8.61898 8.64028 7.74702 8.22713 6.93324L6.84067 7.75363C7.07711 8.31556 7.19731 8.90545 7.19639 9.49934C7.19705 10.0933 7.07657 10.6832 6.83984 11.245L8.22713 12.0654C8.64028 11.2517 8.85223 10.3797 8.85087 9.49934Z",
    fill: "#0067CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1598 9.49934C12.1625 8.04924 11.7513 6.61841 10.9587 5.31934L9.59787 6.1236C10.1802 7.15044 10.5053 8.29429 10.5053 9.49934C10.5074 10.6648 10.1978 11.8166 9.59787 12.8751L10.9587 13.6793C11.7272 12.4205 12.1598 11.0009 12.1598 9.49934Z",
    fill: "#0067CE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15292_137840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.77221 16.4856L1.58351 17.4166L2.51451 13.2279C1.90138 12.0811 1.58155 10.8003 1.58351 9.49992C1.58351 5.12754 5.1278 1.58325 9.50017 1.58325C13.8725 1.58325 17.4168 5.12754 17.4168 9.49992C17.4168 13.8723 13.8725 17.4166 9.50017 17.4166C8.19974 17.4185 6.91903 17.0987 5.77221 16.4856V16.4856ZM6.0018 14.8128L6.51876 15.0899C7.43594 15.58 8.46023 15.8354 9.50017 15.8333C10.7528 15.8333 11.9773 15.4618 13.0188 14.7659C14.0603 14.07 14.8721 13.0808 15.3514 11.9236C15.8308 10.7663 15.9562 9.49289 15.7118 8.26435C15.4674 7.0358 14.8642 5.90731 13.9785 5.02158C13.0928 4.13584 11.9643 3.53265 10.7357 3.28828C9.5072 3.04391 8.23378 3.16933 7.07651 3.64868C5.91924 4.12804 4.93011 4.9398 4.2342 5.98131C3.53828 7.02282 3.16684 8.2473 3.16684 9.49992C3.16684 10.556 3.42413 11.5725 3.911 12.4813L4.1873 12.9983L3.66875 15.3313L6.0018 14.8128V14.8128Z",
    fill: "#0067CE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15292_137840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalkingInformational);
export default __webpack_public_path__ + "static/media/talking-informational.a9741f47cc69478da081968840b92754.svg";
export { ForwardRef as ReactComponent };